import { LocationModel } from '@cpd-app/core-module/models';
import { createAction, props } from '@ngrx/store';
import { OccupationQuickMatchModel } from '@cpd-app/core-module/models';

export const setLocation = createAction(
  '[Location] Set Location',
  props<{ locationModel: LocationModel }>()
);

export const removeLocation = createAction('[Location] Remove Location');

export const receivedOccupationList = createAction(
  '[Occupations By Location] Received Occupations',
  props<{ entities: OccupationQuickMatchModel[] }>()
);

export const loadOccupationListFailure = createAction(
  '[Occupations By Location] Load Occupations List Failure',
  props<{ error: any }>()
);
